import React from 'react'
import classnames from "classnames";
import { Nav, NavItem, NavLink } from 'reactstrap'
import { useState } from 'react';
import Personal from '../PatientDashboard/components/Personal';
import Health from '../PatientDashboard/components/Health';
import Lifestyle from '../PatientDashboard/components/Lifestyle';
import { Link } from 'react-scroll';

const ProfileDetails = () => {
  const [activeTab, setActiveTab] = useState("Personal");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <>
      <div className='nex-list-card-v2'>
        <div className="nexogic-connections-container px-0 row">
          <div className='col-lg-12'>
            <div className='nex-style-section'>
              <ul className='nex-tab-inline'>
                <li className={classnames({
                  active: activeTab === "Personal",
                })}>
                  <Link
                    // className="link-wrapper"
                    onClick={() => {
                      toggle("Personal");
                    }}
                  >
                    Personal
                  </Link>
                </li>
                <li className={classnames({
                  active: activeTab === "Health",
                })}>
                  <Link
                    onClick={() => {
                      toggle("Health");
                    }}
                  >
                    Health
                  </Link>
                </li>
                <li className={classnames({
                  active: activeTab === "Lifestyle",
                })}>
                  <Link
                    onClick={() => {
                      toggle("Lifestyle");
                    }}
                  >
                    Lifestyle
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className='col-lg-12'>
            <div className=" nexogic-so-list-card nex-split-form-container">
              {activeTab === "Personal" && <Personal setActiveTab={setActiveTab} />}
              {activeTab === "Health" && <Health setActiveTab={setActiveTab} />}
              {activeTab === "Lifestyle" && <Lifestyle />}
            </div>
          </div>
        </div>
      </div>
      {/* please remove below code */}
      <div className='nexogic-patient-wrap d-none'>

        <div className="tabs-border-radius  card">

        </div>

        <div className="nexogic-patient-content">

          <div className="border-0 bg-transparent">
            <div className="card-body p-0">
              <Nav tabs className="nexogic-tabs">
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "Personal",
                    })}
                    onClick={() => {
                      toggle("Personal");
                    }}
                  >
                    Personal
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "Health",
                    })}
                    onClick={() => {
                      toggle("Health");
                    }}
                  >
                    Health
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "Lifestyle",
                    })}
                    onClick={() => {
                      toggle("Lifestyle");
                    }}
                  >
                    Lifestyle
                  </NavLink>
                </NavItem>
              </Nav>
              {activeTab === "Personal" && (<>
                <Personal />
              </>
              )}
              {activeTab === "Health" && <Health />}
              {activeTab === "Lifestyle" && <Lifestyle />}
            </div>
          </div>
        </div>
      </div>


    </>
  )
}

export default ProfileDetails